import React, { useEffect, useRef } from 'react';

import { mount, unmount } from 'redom';

import NativeMiniFileInput from './';

function NativeMiniFileInputReactWrapper(props) {

  const wrapperMainReference = useRef(null);
  const nativeMiniFileInputReference = useRef(null);

  useEffect(function onLoad() {

    const container = wrapperMainReference.current;

    const nativeMiniFileInput = new NativeMiniFileInput(props);

    nativeMiniFileInputReference.current = nativeMiniFileInput;

    mount(container, nativeMiniFileInputReference.current);

    return function onUnload() {

      unmount(container, nativeMiniFileInput);

    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onPropsChange() {

    nativeMiniFileInputReference.current.update(props);

  }, [props]);

  function renderMain() {

    const mainAttributes = {
      className: 'mini-file-input-native-react-wrapper-main',
      ref: wrapperMainReference
    };

    return <div {...mainAttributes}>
    
    </div>;

  }

  return renderMain();

}

export default NativeMiniFileInputReactWrapper;